interface IReferralStepDotProps {
    bigSize: string
    smallSize: string
}

export default function ReferralStepDot(props: IReferralStepDotProps) {
    return <div style={{width: props.bigSize, height: props.bigSize, display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "50%", backgroundColor: "black"}}>
        <div style={{width: props.smallSize, height: props.smallSize, borderRadius: "50%", backgroundColor: "white"}}/>
    </div>
}